import { render, staticRenderFns } from "./monitor_buoy.vue?vue&type=template&id=696a4fff&scoped=true&"
import script from "./monitor_buoy.vue?vue&type=script&lang=js&"
export * from "./monitor_buoy.vue?vue&type=script&lang=js&"
import style0 from "./monitor_buoy.vue?vue&type=style&index=0&id=696a4fff&lang=scss&scoped=true&"
import style1 from "./monitor_buoy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a4fff",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VAlert,VBtn,VCard,VIcon,VList,VListItem,VMenu,VSelect,VSlider})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('696a4fff', component.options)
    } else {
      api.reload('696a4fff', component.options)
    }
    module.hot.accept("./monitor_buoy.vue?vue&type=template&id=696a4fff&scoped=true&", function () {
      api.rerender('696a4fff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/chart/monitor_buoy.vue"
export default component.exports